// src/utils/guestListRules.jsx

// Eintrittsarten und ihre "Tagesanzahl"
export const ADMISSION_TYPES = {
    Freitag: 1,
    Samstag: 1,
    Festivalpass: 2
};

// Hauptregelprüfung
export function validateGuestEntry(existingGuests, newAdmissionName) {
    // Schritt 1: Summiere die bisherigen Eintrittstage
    const totalDays = existingGuests.reduce((sum, guest) => {
        const days = ADMISSION_TYPES[guest.admission] || 0;
        return sum + days;
    }, 0);

    const newEntryDays = ADMISSION_TYPES[newAdmissionName] || 0;

    // Schritt 2: Prüfung, ob Grenze (2 Tage) überschritten wird
    if (totalDays + newEntryDays > 2) {
        return {
            valid: false,
            message: `Maximal 2 Eintrittstage erlaubt (bisher: ${totalDays}).`
        };
    }

    // OK
    return { valid: true };
}
